import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Text, Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { confirmCsvUpload } from '../../../../slice/certificateIssuerHomeSlice';

function ConfirmCsvConfirmation(props) {
  const { showConfirmCsvConfirmation, eventId, eventName, handleClose } = props;
  const dispatch = useDispatch();
  const [disableButtons, setDisableButtons] = useState(false);

  const onConfirm = async() => {
    setDisableButtons(true);
    await dispatch(confirmCsvUpload(eventId));
    setDisableButtons(false);
    handleClose();
  };

  return (
    <Modal isOpen={showConfirmCsvConfirmation} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm CSV Upload</ModalHeader>
        <ModalCloseButton disabled={disableButtons} />
        <ModalBody>
          <Box mb={4}>
            <Text fontWeight="bold" mb={2}>Production: {eventName}</Text>
            <Text color="orange.600" mb={2}>⚠️ Important:</Text>
            <Text mb={2}>
              By confirming this CSV:
            </Text>
            <ul style={{ marginLeft: '20px' }}>
              <li>Certificate IDs will be generated for all entries</li>
              <li>You will NOT be able to re-upload or modify the CSV</li>
              <li>This action cannot be reversed</li>
            </ul>
          </Box>
          <Text fontWeight="semibold" color="red.500">
            Are you sure you want to confirm this CSV?
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button 
            colorScheme="gray" 
            mr={3} 
            onClick={handleClose}
            disabled={disableButtons}
          >
            Cancel
          </Button>
          <Button 
            colorScheme="blue" 
            onClick={onConfirm}
            disabled={disableButtons}
            isLoading={disableButtons}
          >
            Confirm CSV
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

ConfirmCsvConfirmation.propTypes = {
  showConfirmCsvConfirmation: PropTypes.bool.isRequired,
  eventId: PropTypes.string.isRequired,
  eventName: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default ConfirmCsvConfirmation;
